import { render, staticRenderFns } from "./FacebookDrawer.vue?vue&type=template&id=1d8dbf74&scoped=true&lang=pug"
import script from "./FacebookDrawer.vue?vue&type=script&lang=js"
export * from "./FacebookDrawer.vue?vue&type=script&lang=js"
import style0 from "./FacebookDrawer.vue?vue&type=style&index=0&id=1d8dbf74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8dbf74",
  null
  
)

export default component.exports